const labelStyles = {
  typography: {
    // Labels
    label1: {
      fontFamily: "Roboto",
      fontSize: "0.875rem", // 14px
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.28571, // 18px / 14px
    },
    label2: {
      fontFamily: "Roboto",
      fontSize: "0.75rem", // 12px
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.33333, // 16px / 12px
    },
    label3: {
      fontFamily: "Roboto",
      fontSize: "0.6875rem", // 11px
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.36364, // 15px / 11px
    },
    label4: {
      fontFamily: "Roboto",
      fontSize: "0.625rem", // 10px
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: 1.4, // 14px / 10px
    },
    overline: {
      fontFamily: "Roboto Flex",
      fontSize: "0.75rem", // 12px
      fontWeight: 400,
      letterSpacing: "1px",
      lineHeight: 2.16667, // 266
      textTransform: "uppercase" as const,
    },
    caption: {
      fontFamily: "Roboto Flex",
      fontSize: "0.75rem", // 12px
      fontWeight: 400,
      letterSpacing: "0.4px",
      lineHeight: 1.38333, // 166
    },
  },
};
export default labelStyles;
